/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ThrottlingUnitRepresentation } from '@veeam-vspc/models/web-controllers';

export const AllowedBandwidthUnits = ThrottlingUnitRepresentation;
export type AllowedBandwidthUnits = ThrottlingUnitRepresentation;
